import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, GrupoEstoque } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GrupoEstoqueService extends BaseResourceService<GrupoEstoque> {

  constructor(
    protected injector: Injector
  ) {
    super(`grupos-estoque`, injector);
  }


  public proximoCodigo(bec: boolean, orgao: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/proximo-codigo/${bec}/${orgao}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
